<template>
  <h-numeric-menu
    v-if="ask"
    :title="__('guests')"
    @input="$emit('create', {
      table,
      guests: $event,
    })"
  >
    <template #activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        depressed
        :rounded="table.type_id == TableType.ROUND"
        color="grey darken-1"
        class="mx-2 my-3 text-none"
        v-text="table.name"
        @contextmenu="$emit('more', $event)"
      />
    </template>
  </h-numeric-menu>
  <v-btn
    v-else
    depressed
    :rounded="table.type_id == TableType.ROUND"
    color="grey darken-1"
    class="mx-2 my-3 text-none"
    v-text="table.name"
    @contextmenu="$emit('more', $event)"
    @click="$emit('create', {
      table,
      guests: 1,
    })"
  />
</template>

<script>
  import TableType from '@/Models/Static/TableType'
  import I18n from '@/Mixins/I18n'
  import HNumericMenu from '@/Components/NumericMenu'

  export default {
    mixins: [
      I18n,
    ],

    components: {
      HNumericMenu,
    },

    props: {
      table: {
        required: true,
        type: Object,
      },
    },

    data: () => ({
      TableType,
    }),

    computed: {
      ask () {
        return this.$store.getters['orders/config/shouldAskGuestsForTable']
      },
    },
  }
</script>
